<template>
    <section id="parallax" class="parallax-section">

        <img class="top" :src="onda" alt="">
        <img class="logo-sm" :src="logoSm" alt="">
        <img class="bottom" :src="onda" alt="">

        <div class="parallax-child-section">
            <section class="fw-main-row" :style="{ 'background-image': 'url(' + background + ')' }">
            </section>
        </div>
    </section>
</template>

<script>
import ImgBackground from '@/assets/img/home/parallax/foto-panoramica-riodejaneiro.jpg'

import ImgOnda from '@/assets/img/home/parallax/onda.svg'
import IcLogoSm from '@/assets/img/home/parallax/logo-sm-white.svg'

export default {
    name: 'Parallax',
    data () {
        return {
            background: ImgBackground,
            onda: ImgOnda,
            logoSm: IcLogoSm
        }
    }
}
</script>

<style lang="sass" scoped>
    @import "../../../assets/sass/_mixin"

    #parallax
        // SVG
        position: relative
        display: flex
        align-items: center
        justify-content: center
        @include device(mobile)
            &
                width: 100%
                height: 300px
        .parallax-child-section
            width: 100%
            height: 300px
            @include device(mobile)
                &
                    clip: rect(0,auto,auto,0)
                    position: absolute
                    top: 0
                    left: 0
            .fw-main-row
                background-position: center center
                background-repeat: no-repeat
                background-size: cover
                height: 300px
                width: 100%
                background-attachment: fixed
                padding: 0rem
                @include device(mobile)
                    &
                        position: fixed
                        display: block
                        top: 0
                        left: 0
                        height: 100%!important
                        transform: translateZ(0)
                        will-change: transform
                        z-index: 1
                        background-attachment: scroll!important
    #parallax
        img
            z-index: 2
            position: absolute
            &.top
                top: -1px
                transform: rotate(180deg)
            &.bottom
                bottom: -1px
            &.logo-sm
                height: 70%

</style>
